import { SwipeableActionsProps } from "./types"
import React from "react"
import SwipeableActionButton from "./swipeable-action-button"
import styled from '~/ui/styled'
import { Flex } from "~components/El"

const Container = styled(Flex)`
  flex-direction: row;
`

const SwipeableActions: React.FC<SwipeableActionsProps> = ({ item, actions, closeSwipe }) => {
  return (
    <Container>
      {actions.map(({ onClick, ...rest }) => {
        return (
          <SwipeableActionButton
            key={rest.icon}
            onClick={() => {
              onClick(item)
              closeSwipe()
            }}
            {...rest}
          />
        )
      })}
    </Container>
  )
}

export default SwipeableActions
